import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-bold",
  templateUrl: "./med-icon-format-bold.component.html",
})
export class MedIconFormatBoldComponent extends SvgMixinComponent {}
